
<div>
    <button mat-button (click)="uploadScripts()">Upload Scripts</button>
    <app-search-input placeholder="Search by title, author, or script ID" (inputChange)="onSearchInput($event)" (search)="search($event)">
        
    </app-search-input>
    <div class="filter-sort-bar">
        <!-- Status Filter Menu -->
        <button mat-stroked-button [matMenuTriggerFor]="statusMenu">
            <mat-icon>filter_list</mat-icon>
            Status Filters
            @if (filters > 0) {
                <span class="badge">{{ getActiveFilterCount() }}</span>
            }
        </button>
        
        <mat-menu #statusMenu="matMenu">
            <div class="menu-content" (click)="$event.stopPropagation()">
                <mat-checkbox (change)="toggleFilters(1)" [checked]="isSet(filters, 1)">
                    <mat-icon>pending</mat-icon> Pending ({{scriptCounts.pending}})
                </mat-checkbox>
                <mat-checkbox (change)="toggleFilters(2)" [checked]="isSet(filters, 2)">
                    <mat-icon>pending_actions</mat-icon> Pending update ({{scriptCounts.pending_update}})
                </mat-checkbox>
                <mat-checkbox (change)="toggleFilters(8)" [checked]="isSet(filters, 8)">
                    <mat-icon>check_circle</mat-icon> Published ({{scriptCounts.published}})
                </mat-checkbox>
                <mat-checkbox (change)="toggleFilters(4)" [checked]="isSet(filters, 4)">
                    <mat-icon>cancel</mat-icon> Rejected ({{scriptCounts.rejected}})
                </mat-checkbox>
                <mat-checkbox (change)="toggleFilters(16)" [checked]="isSet(filters, 16)">
                    <mat-icon>history_toggle_off</mat-icon> Previously published ({{scriptCounts.previously_published}})
                </mat-checkbox>
                <mat-divider></mat-divider>
                <mat-checkbox (change)="toggleIncludeDrafts()" [checked]="includeDrafts">
                    Include drafts
                </mat-checkbox>
            </div>
        </mat-menu>

        <!-- Sort Menu -->
        <button mat-stroked-button [matMenuTriggerFor]="sortMenu">
            <mat-icon>sort</mat-icon>
            Sort: {{ getSortLabel() }}
            <mat-icon>{{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        </button>
        
        <mat-menu #sortMenu="matMenu">
            <button mat-menu-item (click)="updateSort('rating')">
                <mat-icon>star</mat-icon> Rating
            </button>
            <button mat-menu-item (click)="updateSort('views')">
                <mat-icon>visibility</mat-icon> Views
            </button>
            <button mat-menu-item (click)="updateSort('age')">
                <mat-icon>schedule</mat-icon> Age
            </button>
            <button mat-menu-item (click)="updateSort('name')">
                <mat-icon>text_fields</mat-icon> Name
            </button>
            <button mat-menu-item (click)="updateSort('id')">
                <mat-icon>tag</mat-icon> ID (Default)
            </button>
        </mat-menu>
    </div>
</div>

@if (isInitialLoading) {
    <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
        <h3>Loading scripts...</h3>
        <p>Please wait while we fetch the latest data</p>
    </div>
} @else {
    <div style="display: flex; flex-direction: column; gap: 12px;">
        @for (script of scripts; track script.id; let last = $last) {
            <a #scriptItem tabindex="0" [routerLink]="['/admin/scripts', script.id]" style="cursor: pointer; display: block; text-decoration: none; color: inherit;">
                <app-script-card [script]="script" [hideStatus]="false"></app-script-card>
            </a>
        } @empty {
            <div style="text-align: center; margin-top: 20px; color: var(--mat-sys-on-surface-variant)">
                <h3>No scripts found</h3>
                <p>
                    There are no scripts that match the current filters.
                </p>
            </div>
        }
        @if (isLoading) {
            <div style="display: flex; justify-content: center; padding: 12px;">
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
            </div>
        } @else {
            @if (hasMoreData) {
                <button mat-button (click)="loadScripts()">Load more</button>
            } @else {
                <div style="text-align: center; margin-top: 20px; color: var(--mat-sys-on-surface-variant)">
                    <h3>No more scripts</h3>
                </div>
            }
        }
    </div>
}